<template>
  <v-menu offset-y left>
    <template slot="activator">
      <v-btn color="darkgrey" flat icon class="button-element"><v-icon>arrow_drop_down</v-icon></v-btn>
    </template>
    <v-list>
      <v-list-tile v-for="(item, index) in estados" :key="index" @click="changeStatus(item)">
        <v-list-tile-title>{{ item }}</v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  props: {
    requerimiento: Object,
    estados: Array,
    currentStatus: String
  },

  methods: {
    isModified () {
      return this.requerimiento.estadoDisplay !== this.currentStatus
    },
    changeStatus (item) {
      this.$emit('changeCurrentStatus', item)
    }
  }
}
</script>

<style scoped>
.button-element {
  margin: 0;
}
</style>
